import { render } from "./IdentityCard.vue?vue&type=template&id=8a0a72a2&scoped=true&ts=true"
import script from "./IdentityCard.vue?vue&type=script&lang=ts"
export * from "./IdentityCard.vue?vue&type=script&lang=ts"

import "./IdentityCard.vue?vue&type=style&index=0&id=8a0a72a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a0a72a2"]])

export default __exports__